import AuthService from '../services/auth.service';
import { CurrentUserService } from '../services/storage.service';
import ApiService from '../services/api.service';
import moment from 'moment';
import router from '../router';

export default {
    namespaced: true,
    state: {
        token: CurrentUserService.getToken(),
        login: CurrentUserService.getLogin(),
        expirationDate: CurrentUserService.getTokenExpirationDate()
    },
    getters: {
        loggedIn(state) {
            return !!state.token && !!state.login;
        },
        tokenExpirationDate(state) {
            return state.expirationDate;
        },
        hasPermissionTo(state, getter, rootState) {
            return function(action) {
                if (action) {
                    let modulePermission = rootState.permissions.userPermissions;
                    return modulePermission.length ? modulePermission.includes(action) : false;
                } else {
                    return true;
                }
            };
        }
    },
    mutations: {
        setToken(state, token) {
            state.token = token;
            CurrentUserService.setToken(token);
            ApiService.setAccessToken();
        },
        setLogin(state, login) {
            state.login = login;
            CurrentUserService.setLogin(login);
            ApiService.setUserLogin();
        },

        async setTokenExpirationDate(state, value) {
            if (value) {
                let dateWithTimeZone = await moment(value).format();
                CurrentUserService.setTokenExpirationDate(dateWithTimeZone);
            } else {
                CurrentUserService.setTokenExpirationDate(value);
            }
        }
    },
    actions: {
        async signIn({ commit }, payload) {
            let response = await AuthService.signIn(payload);
            return response;
        },
        async signUp({ commit }, payload) {
            let response = await AuthService.signUp(payload);
            return response;
        },
        async refreshToken({ commit, dispatch }, payload) {
            let response = await AuthService.refreshToken();
            if (response.successfull) {
                commit('setToken', response.accessToken.token);
                commit('setTokenExpirationDate', response.accessToken.expires);
                return response.accessToken.token;
            }
        },
        async verifyEmail({ commit }, secretHash) {
            let response = await AuthService.verifyEmail(secretHash);
            return response;
        },
        async restorePassword({ commit }, payload) {
            let response = await AuthService.restorePassword(payload);
            return response;
        },
        async updatePassword({ commit }, payload) {
            let response = await AuthService.updatePassword(payload);
            return response;
        },
        async changePassword({ commit }, payload) {
            let response = await AuthService.changePassword(payload);
            return response;
        },
        async isSecretHashExists({ commit }, secretHash) {
            let response = await AuthService.isSecretHashExists(secretHash);
            return response;
        },
        async logout({ commit }, nonHome = false) {
            let response = await AuthService.logout();
            commit('setToken', '');
            commit('setLogin', '');
            commit('users/setServOrg', {}, { root: true });
            commit('users/setUserHeader', {}, { root: true });
            if (!nonHome) {
                router.replace('/');
            }
            return response;
        }
    }
};
